let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dSgGr"), load("c5uOY"), load("bKvoJ")]).then(() => parcelRequire('aFK6m'));